export default __webpack_public_path__ + "static/media/downArrow.28939fd6.svg";